var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-verify"},[_c('i',{staticClass:"icon icon-lock"}),_c('p',[_vm._v("本站採用SSL256 bits安全加密機制")]),_c('p',{staticClass:"focus"},[_vm._v("授權處理中，請勿關閉視窗或重整頁面")]),_c('div',{staticClass:"progress"},[_c('loading-progress',{attrs:{"status":_vm.getStatus},on:{"updateProgress":_vm.updateProgress}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }